var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHelpFilledIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_7802_62218",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_7802_62218)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.4593 23.0814C18.8331 23.0814 24 17.9145 24 11.5407C24 5.16695 18.8331 0 12.4593 0C6.08556 0 0.918615 5.16695 0.918615 11.5407C0.918615 13.7184 1.52177 15.7552 2.57012 17.4931L0 22.9938L0.870989 23.7274L6.04036 21.133C7.87565 22.3636 10.0837 23.0814 12.4593 23.0814Z",
    fill: "#4611A7"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 6.30497,
    cy: 11.5403,
    rx: 2.30814,
    ry: 2.30814,
    fill: "white"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 12.46,
    cy: 11.5401,
    rx: 2.30814,
    ry: 2.30814,
    fill: "white"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 18.6155,
    cy: 11.5401,
    rx: 2.30814,
    ry: 2.30814,
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelpFilledIcon);
export default __webpack_public_path__ + "static/media/help-filled-icon.e05cd79b537b8f8318d2ceb53cc4c4b7.svg";
export { ForwardRef as ReactComponent };